import {
  homeRoutes,
  dashboardRoutes,
  bookingRoutes,
  requestUserRoutes,
  hrRoutes,
  aiRoutes,
  driveRoutes,
  erpRoutes,
  crmRoutes,
  organizationRoutes,
  authorizationRoutes,
  jobRoutes,
  integrationRoutes,
  settingsRoutes,
  documentationRoutes,
  tournamentRoutes,
  myRoutes
} from 'routes/siteMaps';

/**
 * Gom tất cả nhóm route khai báo trong siteMaps để dựng map `path -> label`.
 * Nhờ vậy mọi page tự có nhãn breadcrumb đẹp mà không cần sửa từng file page.
 */
const ALL_ROUTE_GROUPS = [
  homeRoutes,
  dashboardRoutes,
  bookingRoutes,
  requestUserRoutes,
  hrRoutes,
  aiRoutes,
  driveRoutes,
  erpRoutes,
  crmRoutes,
  organizationRoutes,
  authorizationRoutes,
  jobRoutes,
  integrationRoutes,
  settingsRoutes,
  documentationRoutes,
  tournamentRoutes,
  myRoutes
];

// Duyệt đệ quy một node route, gom mọi cặp { to -> name } vào `map`.
const collect = (node, map) => {
  if (!node) return;
  if (Array.isArray(node)) {
    node.forEach(child => collect(child, map));
    return;
  }
  if (node.to && node.name && !map[node.to]) {
    map[node.to] = node.name;
  }
  if (Array.isArray(node.children)) {
    node.children.forEach(child => collect(child, map));
  }
};

// Tính 1 lần ở cấp module (siteMaps là tĩnh).
const buildPathLabelMap = () => {
  const map = {};
  ALL_ROUTE_GROUPS.forEach(group => collect(group, map));
  return map;
};

export const pathLabelMap = buildPathLabelMap();

// Danh sách phẳng mọi app/route điều hướng được (cho command palette / search).
export const appsList = Object.keys(pathLabelMap).map(to => ({
  to,
  label: pathLabelMap[to]
}));

// Prettify segment khi không tìm thấy nhãn trong siteMaps: "payment-request" -> "Payment Request".
const prettify = segment =>
  segment
    .replace(/-/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());

/**
 * getAutoTrail — suy ra breadcrumb từ URL khi page không tự set.
 * Trả về mảng { label, to, active } (KHÔNG gồm Home — component tự thêm Home).
 */
export const getAutoTrail = pathname => {
  const segments = (pathname || '').split('/').filter(Boolean);

  return segments.map((segment, index) => {
    const to = `/${segments.slice(0, index + 1).join('/')}`;
    const isLast = index === segments.length - 1;
    return {
      label: pathLabelMap[to] || prettify(segment),
      to,
      active: isLast
    };
  });
};

export default getAutoTrail;
